import { ReactNode } from "react";
import { toast } from "sonner-native";
import SuccessLogo from "@/assets/icons/main/greenAlert.svg";

export interface INotifyOptions {
  message: string;
  icon?: ReactNode;
  duration?: number;
}

const useShowToaster = () => {
  return ({
    message,
    icon = <SuccessLogo />,
    duration = 5000,
  }: INotifyOptions) => {
    toast.success(message, {
      icon: icon,
      duration: duration,
    });
  };
};

export default useShowToaster;
